export default (props, vars) => props?.['name'] === 'user';
